module.exports = __webpack_public_path__ + "assets/portrait-icon-note.63a6852b.svg";